"use client";

import { c as _c } from "react/compiler-runtime";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { BoltIcon } from "@heroicons/react/24/solid";
import React from "react";
interface MemesWaveQuickVoteTriggerProps {
  readonly className?: string | undefined;
  readonly onOpenQuickVote: () => void;
  readonly onPrefetchQuickVote?: (() => void) | undefined;
  readonly unratedCount: number;
}
const MemesWaveQuickVoteTrigger: React.FC<MemesWaveQuickVoteTriggerProps> = t0 => {
  const $ = _c(12);
  const {
    className,
    onOpenQuickVote,
    onPrefetchQuickVote,
    unratedCount
  } = t0;
  if (unratedCount <= 0) {
    return null;
  }
  const t1 = `${unratedCount} submissions left unrated in memes wave`;
  const t2 = `${unratedCount} left`;
  const t3 = `tw-flex tw-items-center tw-gap-x-1.5 tw-rounded-full tw-border tw-border-solid tw-border-primary-500/30 tw-bg-primary-500/10 tw-px-2.5 tw-py-2 tw-text-primary-300 tw-shadow-[0_12px_24px_rgba(11,93,255,0.2)] tw-transition-colors tw-duration-300 desktop-hover:hover:tw-border-primary-400/40 desktop-hover:hover:tw-bg-primary-500/15 ${className ?? ""}`;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <BoltIcon className="tw-size-4 tw-flex-shrink-0" />;
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  let t5;
  if ($[1] !== unratedCount) {
    t5 = formatNumberWithCommas(unratedCount);
    $[1] = unratedCount;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== t5) {
    t6 = <span className="tw-text-xs tw-font-semibold">{t5}</span>;
    $[3] = t5;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== onOpenQuickVote || $[6] !== onPrefetchQuickVote || $[7] !== t1 || $[8] !== t2 || $[9] !== t3 || $[10] !== t6) {
    t7 = <button type="button" aria-label={t1} title={t2} onClick={onOpenQuickVote} onFocus={onPrefetchQuickVote} onMouseEnter={onPrefetchQuickVote} className={t3}>{t4}{t6}</button>;
    $[5] = onOpenQuickVote;
    $[6] = onPrefetchQuickVote;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};
export default MemesWaveQuickVoteTrigger;